import React from 'react';
import styles from './BindCallToRequestModal.module.scss';
import { Button, DatePicker, Modal, Spin } from 'antd';
import Table from '../Table/Table';
import SelectedValue from '../SelectedValue/SelectedValue';
import { disabledDate } from '../../utils/utils';

const { RangePicker } = DatePicker;

const Footer = ({ onCancel, onOk, disabled }) => {
  return (
    <div className={styles.footer}>
      <Button onClick={onCancel}>Отмена</Button>
      <Button
        onClick={onOk}
        disabled={disabled}
        type="primary"
      >
        Прикрепить
      </Button>
    </div>
  );
};

const BindCallToRequestModal = ({
  visible,
  onClose,
  value,
  data = [],
  isFetching,
  onRowClick,
  title,
  onSuccess,
  operatorsFilters,
  companiesFilters,
  disabled,
  onChangePicker,
  date,
}) => {
  return (
    <Modal
      title={title}
      visible={visible}
      width="70%"
      destroyOnClose
      zIndex={10000}
      onCancel={onClose}
      footer={
        <Footer
          onCancel={onClose}
          onOk={onSuccess}
          disabled={disabled}
        />
      }
    >
      {isFetching && visible ? (
        <Spin />
      ) : (
        <div className={styles.body}>
          <RangePicker
            onChange={onChangePicker}
            getCalendarContainer={(trigger) => trigger.parentNode}
            disabledDate={disabledDate}
            style={{ width: '50%' }}
            value={date}
            allowClear={false}
          />
          <SelectedValue value={value} />
          <Table
            data={data}
            onRowClick={onRowClick}
            operatorsFilters={operatorsFilters}
            companiesFilters={companiesFilters}
            value={value}
          />
        </div>
      )}
    </Modal>
  );
};

export default BindCallToRequestModal;
